var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnetLogo = function SvgMagnetLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magnetLogo_svg__a)",
    fillRule: "evenodd",
    d: "M0 0v2.864l8.436 4.773 8.276-4.455V.159L8.595 4.932zm0 4.933v2.863l8.436 4.773 5.092-2.74v7.195l3.184-1.91V5.093L8.595 9.865zm0 10.34 3.184 1.75v-4.455L0 10.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magnetLogo_svg__b)",
    d: "M24.71 14.577V1.453h2.75l4.535 9.902 4.679-9.902h2.33v13.124H36.73V5.764l-4.07 8.813h-1.674l-3.994-8.813v8.813z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magnetLogo_svg__c)",
    d: "M48.532 5.416H50.7v9.16h-2.168v-1.235q-.38.623-1.236 1.025a4.2 4.2 0 0 1-1.797.394q-1.92 0-3.253-1.382-1.32-1.382-1.321-3.395 0-1.995 1.322-3.377 1.33-1.382 3.252-1.382.94 0 1.797.402.856.403 1.236 1.025zm-2.586 7.358a3.14 3.14 0 0 0 1.512-.384q.723-.385 1.074-.98V8.6q-.352-.612-1.065-.997a3.1 3.1 0 0 0-1.521-.393q-1.227 0-2.054.796-.828.787-.828 1.977t.828 1.995q.827.796 2.054.796"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magnetLogo_svg__d)",
    d: "M60.115 5.388h2.168v8.85q0 1.867-1.331 3.011-1.322 1.153-3.386 1.153a7.5 7.5 0 0 1-2.472-.42q-1.207-.412-1.855-1.099l1.094-1.446q.561.53 1.389.805.836.285 1.768.284 1.113 0 1.864-.659.76-.65.76-1.665v-1.035q-.38.596-1.235.998-.856.393-1.798.394-1.92 0-3.252-1.355-1.322-1.365-1.322-3.331 0-1.959 1.322-3.304 1.332-1.345 3.252-1.345.95 0 1.798.393.855.394 1.236.998zm-2.587 7.221q.8 0 1.512-.366.723-.375 1.075-.96V8.5q-.352-.595-1.065-.97a3.2 3.2 0 0 0-1.522-.375q-1.227 0-2.054.778-.827.777-.827 1.94 0 1.18.827 1.958.828.778 2.054.778"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magnetLogo_svg__e)",
    d: "M69.653 5.224q1.788 0 2.843 1.116 1.056 1.117 1.056 3.011v5.226h-2.178V9.68q0-1.099-.618-1.74-.609-.64-1.626-.64-.732 0-1.388.348a2.6 2.6 0 0 0-1.008.933v5.995h-2.16V5.416h2.16V6.65q.437-.659 1.226-1.043a3.8 3.8 0 0 1 1.693-.384"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magnetLogo_svg__f)",
    d: "M84.83 9.59q0 .53-.076.905h-7.246q.18 1.117.922 1.748.752.632 1.902.632.808 0 1.484-.312.675-.32 1.008-.85l1.73 1.06q-.533.934-1.664 1.465-1.122.522-2.596.522a5.1 5.1 0 0 1-2.492-.623 4.8 4.8 0 0 1-1.797-1.738 4.7 4.7 0 0 1-.656-2.453q0-1.309.647-2.389a4.7 4.7 0 0 1 1.778-1.71 5.07 5.07 0 0 1 2.482-.623q1.264 0 2.31.576a4.26 4.26 0 0 1 1.656 1.584q.608.997.608 2.205m-7.246-.696h4.964a1.98 1.98 0 0 0-.761-1.4q-.675-.55-1.655-.55-.96 0-1.626.522-.666.512-.922 1.428"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magnetLogo_svg__g)",
    d: "m91.877 12.646.123 1.84q-.465.219-1.17.219-1.605 0-2.596-.943-.988-.951-.988-2.617V7.402H85.42V5.416h1.826V2.954h2.158v2.462h2.501v1.986h-2.5v3.651q0 .778.494 1.245.503.458 1.245.458.352 0 .733-.11"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "magnetLogo_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(7.25 -50.445 -12.031)scale(19.1786 38.0378)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magnetLogo_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(76.6036 2.40977 -1.19974 38.13803 16.973 7.696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magnetLogo_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(76.6036 2.40977 -1.19974 38.13803 16.973 7.696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magnetLogo_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(76.6036 2.40977 -1.19974 38.13803 16.973 7.696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magnetLogo_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(76.6036 2.40977 -1.19974 38.13803 16.973 7.696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magnetLogo_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(76.6036 2.40977 -1.19974 38.13803 16.973 7.696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magnetLogo_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(76.6036 2.40977 -1.19974 38.13803 16.973 7.696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })))));
};
export default SvgMagnetLogo;